/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FinancialSummaryRowDto } from './FinancialSummaryRowDto';
import {
    FinancialSummaryRowDtoFromJSON,
    FinancialSummaryRowDtoFromJSONTyped,
    FinancialSummaryRowDtoToJSON,
    FinancialSummaryRowDtoToJSONTyped,
} from './FinancialSummaryRowDto';
import type { FinancialSummaryTotalDto } from './FinancialSummaryTotalDto';
import {
    FinancialSummaryTotalDtoFromJSON,
    FinancialSummaryTotalDtoFromJSONTyped,
    FinancialSummaryTotalDtoToJSON,
    FinancialSummaryTotalDtoToJSONTyped,
} from './FinancialSummaryTotalDto';

/**
 * 
 * @export
 * @interface BinderClaimFinancialSummaryResponseDto
 */
export interface BinderClaimFinancialSummaryResponseDto {
    /**
     * 
     * @type {Array<FinancialSummaryRowDto>}
     * @memberof BinderClaimFinancialSummaryResponseDto
     */
    financialSummary: Array<FinancialSummaryRowDto>;
    /**
     * 
     * @type {FinancialSummaryTotalDto}
     * @memberof BinderClaimFinancialSummaryResponseDto
     */
    total: FinancialSummaryTotalDto;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimFinancialSummaryResponseDto
     */
    shareOfPremiumSigned: string;
    /**
     * 
     * @type {string}
     * @memberof BinderClaimFinancialSummaryResponseDto
     */
    totalFguMarketLossIndemnityExcCosts: string;
}

/**
 * Check if a given object implements the BinderClaimFinancialSummaryResponseDto interface.
 */
export function instanceOfBinderClaimFinancialSummaryResponseDto(value: object): value is BinderClaimFinancialSummaryResponseDto {
    if (!('financialSummary' in value) || value['financialSummary'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('shareOfPremiumSigned' in value) || value['shareOfPremiumSigned'] === undefined) return false;
    if (!('totalFguMarketLossIndemnityExcCosts' in value) || value['totalFguMarketLossIndemnityExcCosts'] === undefined) return false;
    return true;
}

export function BinderClaimFinancialSummaryResponseDtoFromJSON(json: any): BinderClaimFinancialSummaryResponseDto {
    return BinderClaimFinancialSummaryResponseDtoFromJSONTyped(json, false);
}

export function BinderClaimFinancialSummaryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BinderClaimFinancialSummaryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'financialSummary': ((json['financialSummary'] as Array<any>).map(FinancialSummaryRowDtoFromJSON)),
        'total': FinancialSummaryTotalDtoFromJSON(json['total']),
        'shareOfPremiumSigned': json['shareOfPremiumSigned'],
        'totalFguMarketLossIndemnityExcCosts': json['totalFguMarketLossIndemnityExcCosts'],
    };
}

export function BinderClaimFinancialSummaryResponseDtoToJSON(json: any): BinderClaimFinancialSummaryResponseDto {
    return BinderClaimFinancialSummaryResponseDtoToJSONTyped(json, false);
}

export function BinderClaimFinancialSummaryResponseDtoToJSONTyped(value?: BinderClaimFinancialSummaryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'financialSummary': ((value['financialSummary'] as Array<any>).map(FinancialSummaryRowDtoToJSON)),
        'total': FinancialSummaryTotalDtoToJSON(value['total']),
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'totalFguMarketLossIndemnityExcCosts': value['totalFguMarketLossIndemnityExcCosts'],
    };
}

